<template>
  <div class="create-product">
    <!-- <el-breadcrumb class="my-breadcrumb" separator="/">
      <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 商品管理 </el-breadcrumb-item>
    </el-breadcrumb>-->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleReset"
        @handleFocus="focusCategory"
      ></e-search>
    </div>
    <div class="container">
      <div class="crumbs">
        <el-button type="primary" @click="handleAdd">添加</el-button>
        <el-button @click="handleBatchAdd">批量添加</el-button>
        <el-button @click="handleExport">导出</el-button>
      </div>
      <div>
        <E-Table
          :loading="loading"
          :table-data="tableData"
          :table-label="tableLabel"
          :index-show="true"
        >
          <template #productCatalog="slot">
            <eui-btn
              type="link"
              font-size="12px"
              @click="handleCategoryDialog(slot.scope.row)"
            >
              查看
            </eui-btn>
          </template>
          <template #compositeScore="slot">
            <el-button type="text" @click="handleScoreDialog(slot.scope.row)">
              {{
                slot.scope.row.compositeScore !== undefined
                  ? slot.scope.row.compositeScore
                  : '--'
              }}
            </el-button>
          </template>
          <template #collectCatalog="slot">
            <div class="in3clamp catalog-name">
              {{ slot.scope.row.collectCatalog }}
            </div>
          </template>
          <template #supplier="slot">
            <span
              style="word-break: break-all; color: #2587ff; cursor: pointer"
              type="text"
              @click="goToUrl('./supplierDetail', slot.scope.row)"
            >
              {{ slot.scope.row.supplier }}
            </span>
          </template>
          <template #operation="slot">
            <eui-btn
              type="link"
              font-size="12px"
              @click="handleEditDialog(slot.scope.row)"
            >
              编辑
            </eui-btn>
            <eui-btn
              type="link"
              font-size="12px"
              @click="goToUrl('./supplierDetail', slot.scope.row)"
            >
              详情
            </eui-btn>
            <eui-btn
              type="link"
              font-size="12px"
              @click="goToUrls('/orderManageCaiGou', slot.scope.row)"
            >
              订单
            </eui-btn>
            <eui-btn
              type="link"
              font-size="12px"
              @click="openMessage(slot.scope.row)"
            >
              留言
            </eui-btn>
            <eui-btn
              type="link"
              font-size="12px"
              @click="handleRemove(slot.scope.row)"
            >
              移除
            </eui-btn>
          </template>
        </E-Table>
        <div class="pagination-box">
          <el-pagination
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="queryParams.pageNum"
            :total="total"
            :page-size="queryParams.pageSize"
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <edit-supplier
      :edit-visible.sync="editVisible"
      :supplier-info="supplierInfo"
      @setSubmitPopupData="handleEdit"
      @setUpdateVisible="editVisible = false"
    />
    <!-- 供应商的产品目录 -->
    <product-category-dialog
      :classify-visible.sync="supplierCategoryVisible"
      :category-tree-data="supplierCategoryTreeData"
      @resetPopupData="supplierCategoryVisible = false"
      @submitPopupData="supplierCategoryVisible = false"
    ></product-category-dialog>
    <!-- 所属分类 -->
    <classifyTree
      :classify-visible="searchCategoryVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    ></classifyTree>
    <!-- 供应商评分 -->
    <scoreDialog
      ref="score"
      :score-visible="scoreVisible"
      @submitPopupData="scoreSubmitPopupData"
      @resetPopupData="scoreResetPopupData"
    ></scoreDialog>
    <MessageBoard
      :visible="messageVisible"
      :set-visible="setVisible"
      :current="current"
    />
    <!--添加供应商-->
    <add-supplier-dia
      ref="addSupplier"
      @handleSuccess="getAllList(queryParams)"
    />
    <!--批量添加供应商-->
    <batch-add-supplier
      ref="batchAddSupplier"
      :file-size="2"
      @getBatchImportList="getAllList(queryParams)"
    ></batch-add-supplier>
  </div>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search.vue';
import ETable from '@/modules/projectA/components/common/e-table-list.vue';
import { mapMutations } from 'vuex';
import MessageBoard from '@/modules/projectA/components/messageBoard';
import api from '../../api/user';
import Api from '../../api/agreement';
import editSupplier from './components/editSupplier.vue';
import productCategoryDialog from './components/productCategoryDialog.vue';
import classifyTree from './components/categoryDialog.vue';
import scoreDialog from './components/scoreDialog.vue';
import utils from '../../utils/utils';
import AddSupplierDia from './components/addSupplierDia.vue';
import BatchAddSupplier from './components/batchAddSupplier.vue';

export default {
  /* name: 'goodsMaintenance', */
  components: {
    editSupplier,
    ETable,
    ESearch,
    productCategoryDialog,
    classifyTree,
    scoreDialog,
    MessageBoard,
    AddSupplierDia,
    BatchAddSupplier,
  },
  props: {},
  data() {
    return {
      messageVisible: false,
      current: {},
      loading: false,
      minOrderQuantity: 1,
      editVisible: false,
      supplierCategoryVisible: false,
      searchCategoryVisible: false,
      scoreVisible: false,
      categoryTreeData: [],
      supplierCategoryTreeData: [],
      defaultCheckedKeys: [],
      startDate: '',
      endDate: '',
      // 本页面参数
      filterInfo: {
        fieldList: [
          { label: '供应商名称', type: 'input', value: 'supplier' },
          {
            label: '供应商分级',
            type: 'select',
            value: 'supplierLevel',
            list: 'levelList',
          },
          { label: '产品目录', type: 'dialog', value: 'categoryName' },
          {
            label: '合作状态',
            type: 'select',
            value: 'cooperationStatus',
            list: 'statusList',
          },
          {
            label: '所在地区',
            type: 'select',
            value: 'area',
            list: 'areaList',
          },
          {
            label: '添加时间',
            type: 'date',
            value: 'addTime',
            dateType: 'daterange',
            valueFormat: 'yyyy-MM-dd',
            TimePickerOptions: {
              onPick: (obj) => {
                this.startDate = new Date(obj.minDate).getTime(); // 获取你第一次点击的日期
                this.endDate = new Date(obj.maxDate).getTime(); // 获取你第二次点击的日期
              },
              disabledDate: (time) => {
                if (this.startDate && !this.endDate) {
                  const timeZone = 365 * 24 * 3600 * 1000; // 1年
                  const maxTime = this.startDate + timeZone;
                  const minTime = this.startDate - timeZone;
                  const limitDate =
                    time.getTime() > maxTime || time.getTime() < minTime;
                  return limitDate;
                }
                return '';
              },
            },
          },
          {
            label: '排序选择',
            type: 'select',
            value: 'sortFlag',
            list: 'sortList',
          },
          {
            label: '是否采购',
            type: 'select',
            value: 'tradeFlag',
            list: 'buyList',
          },
          /*  { label: "所属分类", type: "input", value: "categoryName" }, */
        ],
        count: 100,
        btnStyle: [
          { icon: 'el-icon-search', text: '搜索', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' },
        ],
      },
      opentimePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date().getTime() - 86400000;
        },
      },
      listTypeInfo: {
        levelList: [
          { id: null, name: '全部' },
          { id: 1, name: '战略' },
          { id: 2, name: '重要' },
          { id: 3, name: '一般' },
        ],
        statusList: [
          { id: null, name: '全部' },
          { id: 1, name: '启用' },
          { id: 0, name: '停用' },
        ],
        buyList: [
          { id: 0, name: '未采购的' },
          { id: 1, name: '采购过的' },
        ],
        sortList: [
          { id: null, name: '全部' },
          { id: 0, name: '交易量由高到低' },
          { id: 1, name: '交易量由低到高' },
          { id: 2, name: '得分由高到低' },
          { id: 3, name: '得分由低到高' },
        ],
        areaList: [],
        /* {
    key: 1,
    value: "全平台",
  },
  {
    key: 2,
    value: "仅协议客户",
  }, */
      },
      idKey: 'skuId',
      // 列表搜索
      listQuery: {
        supplier: null,
        cooperationStatus: null,
        area: null,
        addTime: [],
        sortFlag: null,
        productCatalog: [],
        categoryName: null,
        supplierLevel: null,
      },
      queryParams: {
        supplierLevel: null,
        supplier: null,
        cooperationStatus: null,
        area: null,
        startDate: null,
        endDate: null,
        sortFlag: null,
        companyId: null,
        productCatalog: [],
        pageNum: 1,
        pageSize: 10,
      },
      cloneListQuery: {},
      cloneQueryParams: {},
      total: 0,
      tableLoading: false,
      tableData: [{}],
      tableLabel: [
        {
          label: '供应商名称',
          align: 'center',
          param: 'supplier',
          width: '180',
          slot: 'supplier',
        },
        {
          label: '综合得分',
          param: 'compositeScore',
          align: 'center',
          minWidth: '100',
          slot: 'compositeScore',
        },
        {
          label: '供应商分级',
          param: 'supplierLevel',
          align: 'center',
          minWidth: '90',
          render: (item) => {
            let str = '';
            switch (item.supplierLevel) {
              case 1:
                str = '战略';
                break;
              case 2:
                str = '重要';
                break;
              case 3:
                str = '一般';
                break;
              default:
                str = '';
                break;
            }
            return str;
          },
        },
        {
          label: '产品目录',
          slot: 'productCatalog',
          align: 'center',
          minWidth: '80',
        },
        {
          label: '常采目录',
          align: 'center',
          slot: 'collectCatalog',
          width: '160',
        },
        {
          label: '合作状态',
          param: 'cooperationStatus',
          align: 'center',
          minWidth: '80',
          render: (item) => {
            let str = '';
            switch (item.cooperationStatus) {
              case 1:
                str = '启用';
                break;
              case 0:
                str = '停用';
                break;
              default:
                str = '';
                break;
            }
            return str;
          },
        },
        {
          label: '交易量(元)',
          param: 'tradeAmount',
          align: 'center',
          minWidth: '130',
        },
        {
          label: '所在地区',
          param: 'area',
          align: 'center',
          minWidth: '110',
        },
        {
          label: '添加时间',
          param: 'createTime',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'operation',
          width: '220',
          fixed: 'right',
        },
      ],
      // 选中的列表数据
      multipleSelection: [],
      multipleSelectionAll: [],
      supplierInfo: {},
    };
  },
  created() {
    this.queryParams.companyId = this.$store.state.USERINFO.companyId;
    this.cloneQueryParams = { ...this.queryParams };
    this.cloneListQuery = { ...this.listQuery };
    this.getAllList(this.queryParams);
  },
  mounted() {
    this.getProvinceList();
  },
  methods: {
    ...mapMutations(['getSupplierScoreInfo']),
    // 获取省列表
    async getProvinceList() {
      const res = await api.queryByParentId();
      if (parseInt(res.code) === 200) {
        const { data } = res;
        data.map((item) => {
          item.id = item.areaId;
          item.name = item.areaName;
        });
        this.listTypeInfo.areaList = data;
      }
    },
    handleEditDialog(row) {
      this.supplierInfo = {};
      for (const key in row) {
        this.$set(this.supplierInfo, key, row[key]);
      }
      this.editVisible = true;
    },
    focusCategory() {
      this.getAllCategoryTree();
      this.searchCategoryVisible = true;
    },
    // 获取分类树数据
    async getAllCategoryTree() {
      const res = await Api.getAllCategoryTree({ categoryId: 0 });
      if (res.code == '200') {
        this.categoryTreeData = res.data.children;
      }
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      const filterNode = [];
      val.map((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.listQuery.productCatalog = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.listQuery.categoryName = arr.join('、');
      this.searchCategoryVisible = false;
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.searchCategoryVisible = false;
    },
    // 编辑供应商保存
    async handleEdit(val) {
      console.log(val);
      const res = await api.saveSupplierInfo(val);
      if (parseInt(res.code) === 200) {
        this.editVisible = false;
        this.getAllList(this.queryParams);
      } else {
        this.editVisible = false;
      }
    },
    // see category
    handleCategoryDialog(row) {
      this.getSupplierCategoryList(row.supplierId);
      this.supplierCategoryVisible = true;
    },
    // judge score
    async handleScoreDialog(row) {
      this.$refs.score.setTableDataScore(row);
      this.scoreVisible = true;
    },
    scoreResetPopupData() {
      this.scoreVisible = false;
    },
    // 提交评分
    async scoreSubmitPopupData(options) {
      console.log(options);
      const params = {};
      options.data.map((item) => {
        params[item.type] = item.grade;
      });
      params.compositeScore = options.score;
      params.supplierId = options.supplierId;
      params.companyId = options.companyId;
      params.id = options.id;
      console.log(params);
      const res = await api.saveSupplierScore(params);
      if (res.code === '200') {
        this.getAllList(this.queryParams);
        this.scoreVisible = false;
      }
    },
    // 获取供应商信息列表
    async getAllList(params) {
      this.tableData = [];
      try {
        this.tableLoading = true;

        const res = await api.getSupplierList(params);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data.records];
          // this.tableData = [{}]
          this.total = data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 添加
    handleAdd() {
      this.$refs.addSupplier.initData();
    },
    // 批量添加
    handleBatchAdd() {
      this.$refs.batchAddSupplier.initData();
    },
    async handleExport() {
      const params = this.queryParams;
      const res = await api.downloadSupplierList(params);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res);
      }
    },

    // 跳转链接
    goToUrl(url, row = {}) {
      // this.$store.commit('getSupplierScoreInfo',row)
      console.log(utils.isEmptyObject(row));
      if (utils.isEmptyObject(row)) {
        this.$router.push({
          path: url,
        });
      } else {
        this.getSupplierScoreInfo(row);
        const { supplierId = '' } = row;
        this.$router.push({
          path: url,
          query: { supplierId },
        });
      }
    },
    goToUrls(url, row = {}) {
      this.$router.push({
        path: url,
        query: { supplier: row.supplier },
      });
    },
    async getSupplierCategoryList(id) {
      const res = await api.querySupplierProductCatalogInfo(id);
      if (parseInt(res.code) === 200) {
        this.supplierCategoryTreeData = res.data;
      }
    },

    //
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getAllList(this.queryParams);
    },
    // 改变条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = val;
      this.getAllList(this.queryParams);
    },
    // 列表搜索
    handleSearch(val) {
      console.log(val);
      const { areaList } = this.listTypeInfo;
      for (let i = 0; i < areaList.length; i++) {
        if (areaList[i].id == val.area) {
          val.area = areaList[i].name;
          break;
        }
      }
      for (const key in val) {
        if (key === 'addTime') {
          this.queryParams.startDate =
            val[key].length > 1 ? `${val[key][0]} ` + `00:00:00` : null;
          this.queryParams.endDate =
            val[key].length > 1 ? `${val[key][1]} ` + `23:59:59` : null;
        }
        //  else if(key === "area"){

        // }
        else {
          this.queryParams[key] = val[key];
        }
      }
      this.queryParams.pageNum = 1;
      console.log(this.queryParams);
      this.getAllList(this.queryParams);
    },
    // 列表搜索重置
    handleReset(val) {
      console.log(val);
      this.listQuery.categoryName = null;
      this.queryParams = { ...this.cloneQueryParams };
      this.listQuery = { ...this.cloneListQuery };
      this.queryParams.categoryName = null;
      this.getAllList(this.queryParams);
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    openMessage(row) {
      const { supplier, supplierId } = row;
      this.current = {
        ...row,
        replyCompanyName: supplier,
        replyCompanyId: supplierId,
      };
      this.messageVisible = true;
    },
    // 移除供应商
    handleRemove(row) {
      this.$confirm(
        '将该供应商移除后，综合得分、合作状态等数据将清空恢复为默认值，是否确认移除？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        // 移除供应商
        api.delete({ id: row.id }).then((res) => {
          if (res.code === '200') {
            this.$message.success('供应商移除成功');
            this.getAllList(this.queryParams);
          }
        });
      });
    },
    setVisible(bool) {
      this.messageVisible = bool;
    },
  },
};
</script>

<style lang="scss" scoped>
.create-product {
  .text-btn {
    color: #0263c9;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  ::v-deep .el-image {
    width: 48px;
    height: 48px;
    display: block;
    font-size: 0;
    ::v-deep img {
      display: block;
      width: 100%;
      width: 100%;
    }
  }
  .wrapper {
    margin-top: 20px;
    background: #fff;
  }
  .search-box {
    background: #fff;
    padding: 10px;
  }

  .handle-box {
    white-space: nowrap;
    background: #fff;
    margin-top: 20px;
    padding: 0 20px;
    min-height: 32px;
    .delete {
      color: #c5c5c5;
    }
  }
  .table-box {
    padding: 10px;
    overflow: hidden;
  }
  .pagination-box {
    text-align: right;
    margin-top: 10px;
  }
  .catalog-name {
    width: 150px;
  }
}
</style>
<style>
.el-tooltip__popper {
  max-width: 320px;
}
</style>
